import { defineComponent as _defineComponent } from 'vue'
import DomService from '@/core/dom.service';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { computed, onMounted, ref, watch } from 'vue';

// Remember to register modals with custom modal names in App.vue

export default /*#__PURE__*/_defineComponent({
  __name: 'SleekModal',
  props: {
    openState: { type: Boolean },
    preloadContent: { type: Boolean },
    modalName: null,
    noScrollEvent: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    openState?: boolean,
    preloadContent?: boolean,
    modalName?: string,
    noScrollEvent?: boolean
}


const renderModal = ref<boolean>(false);
const showModal = ref<boolean>(false);
const delayShowMs = 10;

// Align with maximum animation time for modal classes in <style> below
const closeAnimationTimeMsMobile = 801;
const closeAnimationTimeMsDesktop = 400;

onMounted(() => {
    // If modal has content that takes a while to load, we may render the content immediately in the DOM
    // to allow for a smoother experience when the modal is first opened:
    if (props.preloadContent) {
        if (props.openState) {
            onModalOpen();
        } else {
            renderModal.value = true;
        }
    } else {
        onOpenStateChanged();
    }
});

const breakpointIsActive = useBreakpoints();

const isLargeBreakpoint = computed<boolean>(() => {
    return breakpointIsActive.value.large;
});

function onModalOpen(): void {
    if (!props.noScrollEvent) {
        DomService.addElementClass('html', 'modal-open');
    }
    renderModal.value = true;
    setTimeout(() => {
        showModal.value = true;
    }, delayShowMs);
}

function onModalClose(): void {
    if (!props.noScrollEvent) {
        DomService.removeElementClass('html', 'modal-open');
    }
    showModal.value = false;
    setTimeout(() => {
        renderModal.value = props.openState;
    }, breakpointIsActive.value.large ? closeAnimationTimeMsDesktop : closeAnimationTimeMsMobile);
}

watch(() => props.openState, onOpenStateChanged);
function onOpenStateChanged() {
    if (props.openState) {
        onModalOpen();
    } else {
        onModalClose();
    }
}

return { __sfc: true,props, renderModal, showModal, delayShowMs, closeAnimationTimeMsMobile, closeAnimationTimeMsDesktop, breakpointIsActive, isLargeBreakpoint, onModalOpen, onModalClose, onOpenStateChanged }
}

})